var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarriedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7955,
    cy: 21.2955,
    r: 6.79545,
    stroke: "#A68AFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2046,
    cy: 21.2955,
    r: 6.79545,
    stroke: "#A68AFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7275 5.70139C20.7275 8.75136 15.8834 11.2201 15.6771 11.322C15.6227 11.3493 15.562 11.3636 15.5002 11.3636C15.4385 11.3636 15.3777 11.3493 15.3233 11.322C15.117 11.2201 10.2729 8.75136 10.2729 5.70139C10.2738 4.98519 10.579 4.29855 11.1214 3.79211C11.6639 3.28568 12.3994 3.00081 13.1666 3C14.1304 3 14.9742 3.38691 15.5002 4.04091C16.0262 3.38691 16.87 3 17.8338 3C18.601 3.00081 19.3365 3.28568 19.879 3.79211C20.4215 4.29855 20.7266 4.98519 20.7275 5.70139Z",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarriedActive);
export default __webpack_public_path__ + "static/media/marriedActive.6134baf63580ba4cb0efc0abe051d94b.svg";
export { ForwardRef as ReactComponent };